import React from "react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import logo from "../../assets/logo.png";
import WhyArocoiris from "../WhyArocoiris";

function Navbar() {
  return (
    <AppBar position="static" sx={{ backgroundColor: "#0A192F" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Left section: Logo + Title */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img src={logo} alt="Arocoiris Tech Logo" height="40" />
          <Typography variant="h6" sx={{ ml: 2, fontWeight: "bold" }}>
            Arocoiris Technology
          </Typography>
        </Box>

        {/* Right section: Navigation links */}
        <Box>
          <Button color="inherit" href="/">Home</Button>
          <Button color="inherit" href="/investverse">Product</Button>
          <Button color="inherit" href="/services">Services</Button>
          {/* <Button color="inherit" href="/WhyArocoiris">WhyArocoiris</Button> */}
          <Button color="inherit" href="/careers">Careers</Button>
          <Button color="inherit" href="/contact">Contact</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;